module.exports = __webpack_public_path__ + "130018b5b77b997148d30c723ca67a1f.png";